import { Formik, Form } from 'formik'

import { FormTimestamp } from 'src/components'
import { ImpactTypeForm } from '../impact-type-form.component'
import { useImpactCategoryChanges, useUpdateImpactType } from 'src/hooks'
import { IImpactTypeBase, IImpactTypeBaseWithId } from 'src/types'

import { impactTypeSchema } from 'src/common/validations'

interface UpdateImpactCategoryFormProps {
  handleClose: () => void
  initialValues: IImpactTypeBaseWithId
}

const UpdateImpactCategoryForm = ({
  handleClose,
  initialValues,
}: UpdateImpactCategoryFormProps) => {
  const { data: changes } = useImpactCategoryChanges(initialValues.id)
  const { mutateAsync: update } = useUpdateImpactType()
  const handleSubmit = async (values: IImpactTypeBase) => {
    await update({ ...values, id: initialValues.id })
    handleClose()
  }

  if (!changes) return null

  return (
    <>
      <Formik
        initialValues={{ name: initialValues.name }}
        validationSchema={impactTypeSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <ImpactTypeForm isEditing />
        </Form>
      </Formik>
      <FormTimestamp
        created_at={changes.created?.created_at}
        created_by={changes.created?.user_name ?? changes.created?.user_email}
        updated_at={changes.updated?.created_at}
        updated_by={changes.updated?.user_name ?? changes.updated?.user_email}
      />
    </>
  )
}

export { UpdateImpactCategoryForm }
